import './style.css';

import linkedIn from '../../img/icons/linkedIn.svg';

const socialLinks = [
  {
    id: 'linkedin',
    href: '#!',
    icon: linkedIn,
    label: 'LinkedIn',
    isVisible: false,
  },
];

const Footer = () => {
  const visibleSocialLinks = socialLinks.filter(({ isVisible }) => isVisible);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
          {visibleSocialLinks.length ? (
            <ul className="social__list">
              {visibleSocialLinks.map(({ href, icon, id, label }) => (
                <li key={id} className="social__item">
                  <a href={href} aria-label={label}>
                    <img src={icon} alt="" />
                  </a>
                </li>
              ))}
            </ul>
          ) : null}
          <div className="copyright">
            <p>© 2026 dotPolyline.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
